// Copyright (c) 2016 Deere & Company

import Customer, {getDefaultState} from '@deere/cps-it.warranty-model-factory/lib/customer';
import actions from '../../actions-list';

const updateCustomerDetails = (state, action) =>
    Customer.update(state, {
        $set: action.data
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.CREATE_NEW_CUSTOMER_SUCCESS]: updateCustomerDetails,
        [actions.READ_CUSTOMER_DETAILS_SUCCESS]: updateCustomerDetails,
        [actions.RESET_CUSTOMER_DETAILS]: updateCustomerDetails,
        [actions.UPDATE_CUSTOMER_DETAILS_SUCCESS]: updateCustomerDetails
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/customer/details/reducers/details.js